import routerOptions0 from "/home/runner/work/revolugo/revolugo/node_modules/.pnpm/nuxt@3.19.2_@types+node@24.5.2_@vue+compiler-sfc@3.5.21_eslint@9.35.0_rollup@4.52.0_sas_793d913b687a867020ce47208e3891b7/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}